/*
 * Recording schema — single source of truth for recording packages.
 *
 * Authority: docs/技术方案.md §4 (录制包与事件模型) + §5/§6/§7/§9 接口签名。
 * 任何字段变更必须先在 docs/技术方案.md 同步更新并在 ADR 注册。
 *
 * Only pure data / capability shapes live here. Monaco-/React-/DOM-specific
 * dependencies belong in their feature folders.
 */
export const RECORDING_SCHEMA_VERSION = "0.1.0";
